import { render, staticRenderFns } from "./LibraryComQuestion.vue?vue&type=template&id=0bf6f9fa&scoped=true&"
import script from "./LibraryComQuestion.vue?vue&type=script&lang=js&"
export * from "./LibraryComQuestion.vue?vue&type=script&lang=js&"
import style0 from "./LibraryComQuestion.vue?vue&type=style&index=0&id=0bf6f9fa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf6f9fa",
  null
  
)

export default component.exports